import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  image: {
    flex: '1',
    marginTop: '3rem',
    width: '35%',
    marginRight: '40px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginRight: 0,
    },
  },
  formVertical: {
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
}));

export default useStyles;
